<template>
  <div class="user-seeing" @click="moreVisible = false">
    <div class="silder-contain slider-admissionCue slider-top-see">
      <div class="slider-top clearFloat">
        <p class="h3 slider-title pull-left">{{$t('components.User.change-appoint.62w0n64d00g0')}}</p>
        <div
          class="pull-right h1 btn-close font-gray"
          @click="hideUserSliderBox"
        >
          <i class="el-icon-close"></i>
        </div>
        <el-button
          type="primary"
          @click="changeInviteAction"
          class="pull-right"
          >{{ $t("Common.btn_submit") }}</el-button
        >
      </div>
      <div class="slider-person-info text-1 clearFloat">
        <div class="person" style="display: block">
          <div class="person-img pull-left">
            <img
              v-if="UserInformation.client_img != ''"
              :src="UserInformation.client_img"
            />
            <img
              v-if="
                UserInformation.client_img == '' &&
                  UserInformation.client_sex ==
                    $t('components.User.seeing.52b5hn58u240')
              "
              src="../../assets/images/default-img-women.png"
            />
            <img
              v-if="
                UserInformation.client_img == '' &&
                  UserInformation.client_sex !=
                    $t('components.User.seeing.52b5hn58u240')
              "
              src="../../assets/images/default-img-man.png"
            />
          </div>
        </div>
        <div class="myinfo pb20">
          <div class="sele-sty" style="width: 110px; margin-left: 25px"></div>
          <div class="el-info-row">
            <p class="el-col">
              <label>{{ $t("User.label_text1") }}</label>
              {{ UserInformation.client_cnname }}
            </p>
            <p class="el-col">
              <label>{{ $t("User.label_text2") }}</label>
              {{ UserInformation.client_enname }}
            </p>
          </div>
          <div class="el-info-row">
            <p class="el-col">
              <label>{{ $t("User.label_text3") }}</label>
              {{ UserInformation.client_sex }}
            </p>
            <p class="el-col">
              <label>{{ $t("User.label_text4") }}</label>
              {{ UserInformation.client_mobile }}
            </p>
          </div>
          <div class="el-info-row">
            <p class="el-col">
              <label>{{ $t("User.label_text17") }}</label>
              <span class="contact-name">{{
                UserInformation.main_family_cnname
              }}</span>
              <!-- <span class="addTagBtn ml10" @click="addTagVisable = true"
                >{{$t('components.User.change-appoint.62w0n64d1tc0')}}</span
              > -->
            </p>
            <p class="el-col">
              <label>{{ $t("User.label_text5") }}</label>
              {{ UserInformation.client_birthday }}
            </p>
          </div>
        </div>
      </div>
      <div class="slider-cont text-1" style="padding-top: 50px">
        <el-form :model="formData" ref="formDataRef" label-width="130px">
          <el-form-item
            :label="$t('components.User.change-appoint.62w0n64d2200')"
            prop="coursetype_cnname"
            v-if="formData.coursetype_cnname"
            :rules="[{ required: true, message: $t('components.User.change-appoint.62w0n64d27c0') }]"
          >
            <el-input
              style="width: 350px"
              v-model="formData.coursetype_cnname"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item
            :label="$t('User.ag')"
            prop="coursecat_cnname"
            v-if="formData.coursecat_cnname"
            :rules="[{ required: true, message: $t('User.ah') }]"
          >
            <el-input
              style="width: 350px"
              v-model="formData.coursecat_cnname"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item
            :label="$t('components.User.change-appoint.62w0n64d2ck0')"
            prop="marketer_name"
            :rules="[{ required: true, message: $t('components.User.change-appoint.62w0n64d2h80') }]"
          >
            <el-input
              style="width: 350px"
              v-model="formData.marketer_name"
              disabled
            ></el-input>
          </el-form-item>
          <template v-if="pageFrom == 'invite'">
            <el-form-item
              :label="$t('User.follow_label8')"
              prop="invite_genre"
              :rules="[
                { required: true, message: $t('User.follow_placeholder8') },
              ]"
            >
              <el-input
                style="width: 350px"
                v-model="formData.invite_genre"
                disabled
              ></el-input>
            </el-form-item>
            <el-form-item
              :label="$t('User.follow_label9')"
              prop="invite_visittime"
              :rules="[
                { required: true, message: $t('User.follow_placeholder9') },
              ]"
            >
              <el-date-picker
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                :placeholder="$t('User.follow_placeholder9')"
                v-model="formData.invite_visittime"
                style="width: 350px"
              ></el-date-picker>
            </el-form-item>
          </template>
          <template v-else>
            <el-form-item
              :label="$t('User.follow_label6')"
              prop="audition_genre"
              :rules="[
                { required: true, message: $t('User.follow_placeholder6') },
              ]"
            >
              <el-input
                style="width: 350px"
                v-model="formData.audition_genre"
                disabled
              ></el-input>
            </el-form-item>
            <el-form-item
              :label="$t('User.follow_label10')"
              prop="audition_visittime"
              :rules="[
                { required: true, message: $t('User.follow_placeholder10') },
              ]"
            >
              <el-date-picker
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                :placeholder="$t('User.follow_placeholder10')"
                v-model="formData.audition_visittime"
                style="width: 350px"
                @change="ClickAuditiontime"
              ></el-date-picker>
            </el-form-item>

            <el-form-item
              :label="$t('User.follow_label11')"
              prop="class_cnname"
              :rules="[
                { required: true, message: $t('User.follow_placeholder11_1') },
              ]"
            >
              <el-input
                type="text"
                style="width: 350px"
                :placeholder="$t('User.follow_placeholder11_1')"
                v-model="className"
                @focus="leaning"
                @click="leaning"
              ></el-input>
              <br />
              <el-input
                type="text"
                style="width: 350px; margin-top: 15px"
                :placeholder="$t('User.follow_placeholder11_2')"
                v-model="formData.class_cnname"
              ></el-input>
            </el-form-item>
          </template>
          <el-form-item
            :label="$t('components.User.change-appoint.62w0n64d2lo0')"
            prop="changereason"
            :rules="[{ required: true, message: $t('components.User.change-appoint.62w0n64d2q80') }]"
          >
            <el-input
              style="width: 350px"
              type="textarea"
              rows="5"
              v-model="formData.changereason"
              :placeholder="$t('components.User.change-appoint.62w0n64d2q80')"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import storeUser from "./User.js";
export default {
  name: "userSeeing",
  props: ["clientId", "inviteId", "auditionId", "pageFrom", "ClassMessage"],
  data() {
    return {
      iconWommen: require("../../assets/images/icon/icon-person-women.png"),
      iconmen: require("../../assets/images/icon/icon-person-men.png"),
      photoImgWomen: require("../../assets/images/default-staff-women.png"), //默认女头像
      photoImgmen: require("../../assets/images/default-staff-men.png"), //默认男头像
      //获取数据
      UserInformation: [], //用户基本信息

      className: "",
      formData: {
        coursecat_cnname: "",
        coursecat_id: "",
        coursetype_cnname: "",
        coursetype_id: "",
        invite_genre: "",
        invite_id: "",
        invite_visittime: "",

        audition_genre: "",
        audition_genre_num: "",
        audition_id: "",
        audition_visittime: "",
        class_cnname: "",
        class_id: "",
        hour_id: "",
        course_id: "",

        marketer_name: "",
        track_id: "",
        changereason: "",
      },
    };
  },
  components: {},
  created() {
    this.getclientOneData();
    // invite_id
    // audition_id
    if (this.pageFrom == "invite") {
      this.getInviteOneApi();
    } else if (this.pageFrom == "audition") {
      (() => {})(this.ClassMessage, "ClassMessage");
      this.getAuditionOneApi();
    }
  },

  computed: {
    ClassMessageinfo() {
      return this.ClassMessage;
    },
  },

  watch: {
    ClassMessageinfo(n) {
      (() => {})(n, "nnnn");
      this.formData.class_id = n.class_id;
      this.formData.hour_id = n.hour_id;
      this.formData.course_id = n.course_id;
      this.formData.class_cnname = n.class_cnname;
      this.className = n.class_cnname;

      let classHourTime = n.hour_time.split("-")[0] + ":00";
      this.formData.audition_visittime = this.getDate(
        n.hour_day,
        classHourTime
      );
    },
  },

  methods: {
    hideUserSliderBox() {
      this.$emit("hideUserSliderBox");
    },

    getclientOneData() {
      var fromValue;
      if (this.isForm) {
        fromValue = "1";
      } else {
        fromValue = "";
      }
      storeUser
        .getclientOne({
          client_id: this.clientId,
          from: fromValue,
        })
        .then((res) => {
          this.UserInformation = res.data.data.list;
        });
    },

    getInviteOneApi() {
      storeUser
        .getInviteOneApi({
          invite_id: this.inviteId,
        })
        .then((res) => {
          const { code, data: _jb } = res.data;

          const data = _jb;
          if (code === 200) {
            const {
              coursecat_id,
              coursecat_cnname,
              coursetype_id,
              coursetype_cnname,
              invite_genre,
              invite_id,
              invite_visittime,
              marketer_name,
              track_id,
            } = data;
            this.formData.coursecat_id = coursecat_id;
            this.formData.coursecat_cnname = coursecat_cnname;
            this.formData.coursetype_id = coursetype_id;
            this.formData.coursetype_cnname = coursetype_cnname;
            this.formData.invite_genre = invite_genre;
            this.formData.invite_id = invite_id;
            this.formData.invite_visittime = invite_visittime;
            this.formData.marketer_name = marketer_name;
            this.formData.track_id = track_id;
          }
        });
    },
    getAuditionOneApi() {
      storeUser
        .getAuditionOneApi({
          audition_id: this.auditionId,
        })
        .then((res) => {
          (() => {})(res);
          const { code, data: _jb } = res.data;

          const data = _jb;
          if (code === 200) {
            const {
              coursecat_id,
              coursecat_cnname,
              coursetype_id,
              coursetype_cnname,
              audition_genre,
              audition_id,
              audition_visittime,
              marketer_name,
              track_id,

              audition_genre_num,
              class_cnname,
              class_id,
              hour_id,
              course_id,
            } = data;

            this.formData.coursecat_id = coursecat_id;
            this.formData.coursecat_cnname = coursecat_cnname;
            this.formData.coursetype_id = coursetype_id;
            this.formData.coursetype_cnname = coursetype_cnname;
            this.formData.audition_genre = audition_genre;
            this.formData.audition_id = audition_id;
            this.formData.audition_visittime = audition_visittime;
            this.formData.marketer_name = marketer_name;
            this.formData.track_id = track_id;
            this.formData.audition_genre_num = audition_genre_num;
            this.formData.class_cnname = class_cnname;
            this.className = class_cnname;
            this.formData.class_id = class_id;
            this.formData.hour_id = hour_id;
            this.formData.course_id = course_id;

            this.$emit("ClickAudition", audition_genre_num);
            this.$emit("ClickAuditiontime", audition_visittime);
          }
        });
    },
    ClickAuditiontime() {
      this.formData.class_cnname = "";
      this.className = "";
      this.formData.class_id = "";
      this.$emit("ClickAuditiontime", this.formData.audition_visittime);
    },
    getDate(strDate, strTime) {
      let b = strDate.split("-");
      let c = strTime.split(":");
      let date = new Date(b[0], b[1] - 1, b[2], c[0], c[1], c[2]);
      return this.$Common.formatDate(date);
    },
    leaning() {
      if (this.formData.coursecat_id && this.formData.coursetype_id) {
        this.$emit("leaning", {
          coursecat_id: this.formData.coursecat_id,
          coursetype_id: this.formData.coursetype_id,
        });
      } else {
        this.$emit("leaning");
      }
    },

    changeInviteAction() {
      this.$refs["formDataRef"].validate((v) => {
        if (v) {
          storeUser
            .changeInviteAction({
              time:
                this.pageFrom == "invite"
                  ? this.formData.invite_visittime
                  : this.formData.audition_visittime,
              track_id: this.formData.track_id,
              invite_id: this.inviteId,
              audition_id: this.auditionId,
              class_id: this.formData.class_id,
              hour_id: this.formData.hour_id,
              course_id: this.formData.course_id,
              class_cnname: this.className,
              coursecat_id: this.formData.coursecat_id,
              coursetype_id: this.formData.coursetype_id,
              changereason: this.formData.changereason,
            })
            .then((res) => {
              const { code, msg } = res.data;
              this.$message({
                type: code === 200 ? "success" : "error",
                message: msg,
              });
              if (code === 200) {
                this.hideUserSliderBox();
                this.$emit("updatelist");
              }
            });
        } else {
          return;
        }
      });
    },
  },
};
</script>

<style lang="less">
.slider-top-see .myinfo .el-info-row {
  margin-right: 25px !important;
}

.user-seeing .slider-top-see {
  .slider-person-info {
    .myinfo {
      margin-bottom: 12px;

      .contact-name {
        min-width: 50px;
        display: inline-block;
      }
    }
  }

  .form-info-cont .course {
    flex: none !important;
  }
}
</style>
